/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CareerListResponse,
  CareerLocalizationRequest,
  CareerLocalizationResponse,
  CareerRequest,
  CareerResponse,
  Error,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Careers<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Career
   * @name GetCareers
   * @request GET:/careers
   * @secure
   */
  getCareers = (
    query?: {
      /** Sort by attributes ascending (asc) or descending (desc) */
      sort?: string;
      /** Return page/pageSize (default: true) */
      "pagination[withCount]"?: boolean;
      /** Page number (default: 0) */
      "pagination[page]"?: number;
      /** Page size (default: 25) */
      "pagination[pageSize]"?: number;
      /** Offset value (default: 0) */
      "pagination[start]"?: number;
      /** Number of entities to return (default: 25) */
      "pagination[limit]"?: number;
      /** Fields to return (ex: title,author) */
      fields?: string;
      /** Relations to return */
      populate?: string;
      /** Filters to apply */
      filters?: Record<string, any>;
      /** Locale to apply */
      locale?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CareerListResponse, Error>({
      path: `/careers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Career
   * @name PostCareers
   * @request POST:/careers
   * @secure
   */
  postCareers = (data: CareerRequest, params: RequestParams = {}) =>
    this.request<CareerResponse, Error>({
      path: `/careers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Career
   * @name GetCareersId
   * @request GET:/careers/{id}
   * @secure
   */
  getCareersId = (id: number, params: RequestParams = {}) =>
    this.request<CareerResponse, Error>({
      path: `/careers/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Career
   * @name PutCareersId
   * @request PUT:/careers/{id}
   * @secure
   */
  putCareersId = (
    id: number,
    data: CareerRequest,
    params: RequestParams = {},
  ) =>
    this.request<CareerResponse, Error>({
      path: `/careers/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Career
   * @name DeleteCareersId
   * @request DELETE:/careers/{id}
   * @secure
   */
  deleteCareersId = (id: number, params: RequestParams = {}) =>
    this.request<number, Error>({
      path: `/careers/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Career
   * @name PostCareersIdLocalizations
   * @request POST:/careers/{id}/localizations
   * @secure
   */
  postCareersIdLocalizations = (
    id: number,
    data: CareerLocalizationRequest,
    params: RequestParams = {},
  ) =>
    this.request<CareerLocalizationResponse, Error>({
      path: `/careers/${id}/localizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
